import { StillSize, ImageSize as imageType } from '#enums/imageSizes.ts';
import { SectionType } from '#enums/mediaTypes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { type Config } from '#types.ts';
import { type TileItem } from '../../Tile/types.ts';
import { type SeasonEpisodesData } from '../types.ts';

export const formatEpisodes = (
  data: SeasonEpisodesData | null | undefined,
  tvId: string | number,
  seasonNumber: number,
  { images }: Config,
) =>
  data
    ? (data.season.episodes ?? []).reduce((acc: TileItem[], episode) => {
        if (!episode) {
          return acc;
        }

        const { episodeNumber, id, name, stillPath, voteAverage } = episode;
        const subTitle = `Episode ${String(episodeNumber)}`;

        acc.push({
          id,
          src: buildImagePath(stillPath, imageType.Still, StillSize.LG, images),
          subTitle: subTitle === name ? '' : subTitle,
          title: name,
          type: SectionType.Episode,
          videoPathIds: [tvId, seasonNumber, episodeNumber],
          voteAverage,
        });

        return acc;
      }, [])
    : [];
